export default __webpack_public_path__ + "433579ad8d616c8616091e8b99bac884.png";